import React from 'react';
import PropTypes from 'prop-types';
import LottiePlayer from 'lottie-react';
import loadingAnimation from './loading.json';

const FullScreenLoader = ({ loading = false }) => {
    if (!loading) return null;
    return (
        <div className="centered-div">
            <LottiePlayer
                animationData={loadingAnimation}
                style={{ height: 250 }}
                autoplay
                loop
            />
        </div>
    );
};

FullScreenLoader.propTypes = {
    loading: PropTypes.bool,
};

export default FullScreenLoader;
